import { useState } from "react";

import Header from "../Components/Header";
import applyMarkReceived from "../css/applyMarkReceived";
import { BRAND } from "../css/brand";
import BlueButton from "../Components/BlueButton";
import Badge from "../Components/Badge";
import RedButton from "../Components/RedButton";
import { CheckCircle2, XCircle } from "lucide-react";
export default function Payments() {
  const [rows, setRows] = useState([
    { invoice: "INV-90021", entity: "DST-101", name: "Dist Pune", amount: 52400, date: "2025-09-22", status: "Pending", receivedAmount: null, receivedDate: null },
    { invoice: "INV-90022", entity: "RT-1002", name: "Ganesh Telecom", amount: 34990, date: "2025-09-21", status: "Received", receivedAmount: 34990, receivedDate: "2025-09-21" },
  ]);
  const [confirmIdx, setConfirmIdx] = useState(null);
  const [confirmAmount, setConfirmAmount] = useState("");
  const [confirmDate, setConfirmDate] = useState(() => new Date().toISOString().slice(0, 10));

  const openConfirm = (i) => { setConfirmIdx(i); const r = rows[i]; setConfirmAmount(String(r.amount)); setConfirmDate(new Date().toISOString().slice(0, 10)); };
  const markReceived = () => { if (confirmIdx === null) return; const next = applyMarkReceived(rows, confirmIdx, confirmAmount, confirmDate); if (next === rows) { alert("Enter valid amount and date."); return; } setRows(next); setConfirmIdx(null); };
  const markPending = (i) => { setRows((prev) => prev.map((r, idx) => (idx === i ? { ...r, status: "Pending", receivedAmount: null, receivedDate: null } : r))); };

  return (
    <div className="space-y-3 sm:space-y-4">
      <Header brand={BRAND} title="Payments" />
      <div className="overflow-x-auto rounded-2xl border bg-white shadow-sm">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50">
            <tr className="text-left text-xs uppercase tracking-wide text-slate-500">
              <th className="px-4 py-3">Invoice</th>
              <th className="px-4 py-3">Entity</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Received</th>
              <th className="px-4 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.invoice} className="border-b last:border-0 align-top">
                <td className="px-4 py-3 font-medium">{r.invoice}</td>
                <td className="px-4 py-3">{r.name} ({r.entity})</td>
                <td className="px-4 py-3">₹ {r.amount.toLocaleString("en-IN")}</td>
                <td className="px-4 py-3">{r.date}</td>
                <td className="px-4 py-3">{Badge(r.status, r.status === "Received" ? "blue" : "red")}</td>
                <td className="px-4 py-3">{r.receivedAmount ? (<div className="text-xs leading-5"><div>₹ {r.receivedAmount.toLocaleString("en-IN")}</div><div className="text-slate-500">{r.receivedDate}</div></div>) : (<span className="text-slate-400 text-xs">—</span>)}</td>
                <td className="px-4 py-3">
                  <div className="flex flex-wrap gap-2">
                    <BlueButton brand={BRAND} onClick={() => openConfirm(i)}><CheckCircle2 size={14} className="mr-1 inline" />Mark Paid</BlueButton>
                    <RedButton brand={BRAND} onClick={() => markPending(i)}><XCircle size={14} className="mr-1 inline" />Mark Pending</RedButton>
                  </div>
                  {confirmIdx === i && (
                    <div className="mt-3 rounded-xl border p-3">
                      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
                        <input value={confirmAmount} onChange={(e) => setConfirmAmount(e.target.value)} placeholder="Amount received (₹)" className="rounded-lg border px-3 py-2 text-sm" />
                        <input type="date" value={confirmDate} onChange={(e) => setConfirmDate(e.target.value)} className="rounded-lg border px-3 py-2 text-sm" />
                        <div className="flex items-center gap-2 justify-end">
                          <RedButton brand={BRAND} onClick={() => setConfirmIdx(null)}>Cancel</RedButton>
                          <BlueButton brand={BRAND} onClick={markReceived}>Confirm</BlueButton>
                        </div>
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}